import { render, staticRenderFns } from "./records.vue?vue&type=template&id=79a5f14d&scoped=true&"
import script from "./records.vue?vue&type=script&lang=js&"
export * from "./records.vue?vue&type=script&lang=js&"
import style0 from "./records.vue?vue&type=style&index=0&id=79a5f14d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5f14d",
  null
  
)

export default component.exports